import React, { useEffect, useState } from 'react'

import { Button, Icon, Payment } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, string } from 'prop-types'

const NAVIGATION_SAFETY_TIMEOUT_MS = 1500

function SubscribeButton({ paymentFormPath, label = 'Subscribe and save', onClick: handleClick }) {
  // SSR-stable href: this button renders on the cacheable item page. Deriving the return_url
  // from window.location during render would diverge from the SSR markup and cause hydration
  // drift, so we render paymentFormPath first and append return_url only after hydration.
  const [href, setHref] = useState(paymentFormPath)

  useEffect(() => {
    try {
      const url = new URL(paymentFormPath, window.location.origin)
      url.searchParams.set('return_url', window.location.href)
      setHref(url.toString())
    } catch { /* keep paymentFormPath */ }
  }, [paymentFormPath])

  const handleNavigate = (event) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return

    event.preventDefault()

    let navigated = false
    const navigate = () => {
      if (navigated) return
      navigated = true
      window.location.href = href
    }

    if (typeof handleClick === 'function') {
      handleClick(navigate)
      setTimeout(navigate, NAVIGATION_SAFETY_TIMEOUT_MS)
    } else {
      navigate()
    }
  }

  return (
    <Button
      type="primary-warning"
      size="large"
      customClass="pricing-area__actions-button pricing-area__subscribe-button"
      trailIcon={<Icon svgComponent={Payment} />}
      href={href}
      onClick={handleNavigate}
      aria-label={label}
    >
      {label}
    </Button>
  )
}

SubscribeButton.propTypes = {
  paymentFormPath: string.isRequired,
  label: string,
  onClick: func,
}

export default SubscribeButton
